<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div class="agencyTasksView">

		<div>
			<v-card-title class="toolbar-agency-task"><h2>Zadania konkursowe</h2></v-card-title>
		</div>
		<div style="display: flex" class="mt-4">
		<div>
			<v-btn class="ml-3" color="primary" @click="addTaskMenuVisible = true">Dodaj zadanie</v-btn>
		</div>
		<div>
			<v-btn class="ml-3" color="primary" @click="importFromOtherContestVisible = true">Importuj zadania z innego
				naboru
			</v-btn>
		</div>
		<div>
			<v-btn class="ml-3" color="primary" @click="changeTextDialog = true">Znajdź i Zamień
			</v-btn>
		</div>
		<div>
			<v-btn class="ml-3" color="primary" @click="rerenderTreeview(!openTree)">{{openTree ? 'Zwiń elementy' : 'Rozwiń elementy'}}
			</v-btn>
		</div>
		</div>
		<text-changer 
			:changeTextDialog="changeTextDialog"
			@closeTextChangerDialog="changeTextDialog=false"
			@refresh="refresh"
			@textChangeError="displayGlobalTextChangeDialog"
			></text-changer>
		<egranty-input-field-popup
			:is-open.sync="importFromOtherContestVisible"
			title="Importuj z konkursu"
			label="Nazwa konkursu"
			field-type='SELECT'
			:select-items="contests"
			@save="importFromContest"
		></egranty-input-field-popup>
		<egranty-input-field-popup
			:is-open.sync="addTaskMenuVisible"
			title="Dodaj nowe zadanie"
			label="Nazwa zadania"
			for="agency-task-view-name-task"
			id="agency-task-view-name-task"
			long
			@save="addTask"
		></egranty-input-field-popup>
		
		<v-card>
			<v-layout
				justify-space-between
				pa-3
			>
				<v-flex xs5>
					<v-treeview v-if="rendered"
						class="agency-tasks-view-tree-view"
						style="width: 180%"
						:key="keyValue"
						v-model="tree"
						:active.sync="active"
						:items="tasks"
						:open-all="openTree"
						activatable
						:open.sync="open"
						item-key="uniqueName"
						:return-object=true
					>
						<template v-slot:prepend="{ item }">

							<v-icon v-if="item.type ==='task'"> label</v-icon>
							<v-icon v-if="item.type ==='country'"> label</v-icon>
							<v-icon v-if="item.type ==='priority'"> label</v-icon>
							<v-icon v-if="item.type ==='area' && item.hasProblems === true" style="color:red">
								priority_high
							</v-icon>
							<v-icon v-if="item.type ==='area' && item.hasProblems !== true">label</v-icon>

						</template>
					</v-treeview>
				</v-flex>
				<v-flex d-flex
					text-xs-center class="agency-tasks-view-tree">
					<v-card v-if="active.length"
						max-width="500"
					>

						<task-tab
							:disabled="contestData.open"
							v-if="active[0].type==='task'"
							:active="active"
							:copiedObject="copiedObject"
							@refresh="refresh"
							@removalError="displayErrorDialog"
							@duplicateError="displayDuplicationErrorDialog"
						></task-tab>

						<country-tab
							:disabled="contestData.open"
							v-if="active[0].type==='country'"
							:active="active"
							:copiedObject="copiedObject"
							@refresh="refresh"
							@removalError="displayErrorDialog"
							@copyObject="copyObject"
							@copyError="displayCopyPrioritiesErrorDialog"
						></country-tab>

						<priority-tab
							:disabled="contestData.open"
							v-if="active[0].type==='priority'"
							:active="active"
							:copiedObject="copiedObject"
							@refresh="refresh"
							@removalError="displayErrorDialog"
							@copyObject="copyObject"
							@copyError="displayCopyAreasErrorDialog"
						></priority-tab>

						<area-tab
							:disabled="contestData.open"
							v-if="active[0].type==='area'"
							:active="active"
							:copiedObject="copiedObject"
							@refresh="refresh"
							@removalError="displayErrorDialog"
							@copyObject="copyObject"
						></area-tab>

					</v-card>
				</v-flex>
			</v-layout>
		</v-card>

		<egranty-error-list-popup
			title="Nie udało się usunąć zadań"
			:error-list="taskRemovingErrors.messages"
			:is-open="taskRemovingErrors.showPopup"
			@close="closeTaskRemovingErrorsPopup"
		/>
	</div>
</template>

<script>
	import EgrantyInputFieldPopup from "../../../genericComponents/EgrantyInputFieldPopup";
	import {AgencyTask} from "@/api/generated/AgencyTask";
	import PriorityTab from "./components/PriorityTab";
	import CountryTab from "./components/CountryTab";
	import AreaTab from "./components/AreaTab";
	import TaskTab from "./components/TaskTab";
	import TextChanger from "./components/TextChanger";
	import {AgencyContest} from "@/api/generated/AgencyContest";
	import EgrantyErrorListPopup from "../../../genericComponents/EgrantyErrorListPopup";

	export default {
		name: "AgencyTasksView",

		components: {
			EgrantyErrorListPopup, TaskTab, PriorityTab, CountryTab, AreaTab, EgrantyInputFieldPopup, TextChanger
		},

		methods: {
			getContestId () {
				return this.$route.params.id;
			},

			importFromContest (otherContestId) {
				this.importFromOtherContestVisible = false;
				AgencyTask.postImportFromContest(this, this.$route.params.id, otherContestId,
					() => {
						this.refresh();
					},
					errorResponse => {
						if (errorResponse.status === "NOT_ACCEPTABLE") {
							this.displayErrorDialog(errorResponse);
						}
					});
			},

			displayErrorDialog (errorResponse) {
				this.$messagesBus.$emit("error", "Usunięcie nie udało się", errorResponse);
				this.taskRemovingErrors.title = "Nie udało się usunąć zadań";
				this.taskRemovingErrors.messages = errorResponse.message.split("\n");
				this.taskRemovingErrors.showPopup = true;
			},
			displayDuplicationErrorDialog (errorResponse) {
				this.$messagesBus.$emit("error", "Utworzenie duplikatu nie powiodło się");
				this.taskRemovingErrors.title = "Nie udało się utworzyć duplikatu";
				this.taskRemovingErrors.messages = errorResponse.message.split("\n");
				this.taskRemovingErrors.showPopup = true;
			},
			displayCopyPrioritiesErrorDialog(errorReponse) {
				this.$messagesBus.$emit("error", "Skopiowanie priorytetów nie powiodło się");
				this.taskRemovingErrors.title = "Nie udało się skopiować priorytetów";
				this.taskRemovingErrors.messages = errorReponse.message.split("\n");
				this.taskRemovingErrors.showPopup = true;
			},
			displayCopyAreasErrorDialog(errorReponse){
				this.$messagesBus.$emit("error", "Skopiowanie obszarów nie powiodło się");
				this.taskRemovingErrors.title = "Nie udało się skopiować obszarów";
				this.taskRemovingErrors.messages = errorReponse.message.split("\n");
				this.taskRemovingErrors.showPopup = true;
			},
			displayGlobalTextChangeDialog(errorReponse){
				this.$messagesBus.$emit("error", "Globalna edycja tekstu nie powiodła się");
				this.taskRemovingErrors.title = "Nie udało się wyedytować tekstu globalnie";
				this.taskRemovingErrors.messages = errorReponse.message.split("\n");
				this.taskRemovingErrors.showPopup = true;
			},

			addTask(name) {
				AgencyTask.putTask(this, this.getContestId(), name, () => {
					this.refresh();
				});
				this.addTaskMenuVisible = false;
			},

			refresh () {
				this.loadTasksTree();
			},

			closeTaskRemovingErrorsPopup () {
				this.taskRemovingErrors.showPopup = false;
			},

			removeActiveElement(){
				this.active = [];
			},

			rerenderTreeview (openTree) {
			  	this.openTree = openTree;
      			this.rendered = false;
      			this.$nextTick(() => {
        			this.rendered = true;
      			});
				// this.removeActiveElement();
   			},
			copyObject(object){
				this.copiedObject = object;
				this.$messagesBus.$emit("success", "Skopiowano element");
			},

			loadTasksTree(){
				AgencyTask.getTasksTree(this, this.getContestId(), (response) => {
					this.tasks = response;
					for (let i = 0; i < this.tasks.length; i++) {
						let task = this.tasks[i];
						task.type = "task";
						task.uniqueName = task.id + task.type;
						task.children = task.countries;
						for (let j = 0; j < task.countries.length; j++) {
							let country = task.countries[j];
							country.type = "country";
							country.taskName = task.name;
							country.uniqueName = country.id + country.type;
							country.children = country.priorities;
							for (let k = 0; k < country.priorities.length; k++) {
								let priority = country.priorities[k];
								priority.type = "priority";
								priority.taskName = task.name;
							priority.countryName = country.name;
							priority.uniqueName = priority.id + priority.type;
								priority.children = priority.areas;
								for (let l = 0; l < priority.areas.length; l++) {
									let area = priority.areas[l];
									area.type = "area";
									area.uniqueName = area.id + area.type;
								}
							}
						}
					}
					this.removeActiveElement();
				});
			},
		},

		data () {
			return {
				contests: [],
				importFromOtherContestVisible: false,
				addTaskMenuVisible: false,
				tree: [],
				tasks: [],
				open: [],
				keyValue: 0,
				active: [],
				left: 0,
				contestData: {
					id: this.$route.params.id,
					open: undefined,
				},
				taskRemovingErrors: {
					showPopup: false,
					messages: [],
					title: ""
				},
				rendered: true,
				copiedObject : {
					id: null,
					type: null
				},
				changeTextDialog: false,
				openTree: false,
			};
		},

		mounted () {
			this.loadTasksTree();
			AgencyContest.getAllContestNames(this, response => {
				this.contests = response.filter(x => x.id !== Number.parseInt(this.getContestId()));
			});
			AgencyContest.getState(this, this.contestData.id,
				response => this.contestData.open = response.agencyContestAnnouncementStatus === 'ANNOUNCED');
		},

	};
</script>
<style>

	.agency-tasks-view-tree-view .v-treeview-node__label {
		word-wrap: break-word !important;
		width: 90% !important; 	
	}
	.agency-tasks-view-tree-view .v-treeview-node__content {
		word-wrap: break-word !important;
		width: 90%;
	}
	.agency-tasks-view-tree-view .v-icon {
		display: block;
	}
	.agency-tasks-view-tree {
		position: fixed;
		top: 300px;
		right: 100px;
	}

	

</style>

<!--<style lang="css" scoped>-->
<!--	.v-treeview-node__label-->
<!--	{-->
<!--		width: 250px;-->
<!--		word-wrap: break-word;-->
<!--	}-->
<!--&gt;</style>-->
